import { render, staticRenderFns } from "./user-notifications.vue?vue&type=template&id=1326b0d2&scoped=true&"
import script from "./user-notifications.vue?vue&type=script&lang=js&"
export * from "./user-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326b0d2",
  null
  
)

export default component.exports